import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { memo } from 'react';
import { a2l } from 'shared/map/lib/utils';
import { removeNulls } from 'utils';
import { DeviceMarker } from 'entities/device.map.markers/ui/index';
import { lastGPS2Position, onDeviceMarkerClick } from 'entities/device.map.markers/lib';
import { useAction, useAppSelector } from 'shared/hooks/redux/hooks';
import { select_ui_settings } from 'console/redux/settings-actions';
import { pickDevice } from 'console/redux/main-actions';
export const DeviceMarkers = memo(function DeviceMarkers(props) {
    const { markers_info, icon_size, labels_visible, onClick } = props;
    return (_jsx(_Fragment, { children: markers_info
            .filter((marker) => marker.locations != null)
            .map((marker) => {
            if (marker.locations) {
                const [prev_position, position] = lastGPS2Position(removeNulls(marker.locations));
                if (position != null) {
                    return (_jsx(DeviceMarker, { position: a2l(position), prev_position: prev_position != null
                            ? a2l(prev_position)
                            : a2l(position), color: marker.color, icon_size: icon_size, name: marker.name, label_visible: labels_visible, onClick: onClick
                            ? onDeviceMarkerClick(onClick)(marker.id)
                            : undefined, online: marker.online }, marker.id));
                }
            }
            return null;
        }) }));
});
export const DeviceMarkersOnTrack = memo(function DeviceMarkersOnTrack(props) {
    const { markers_info } = props;
    const icon_size = useAppSelector((state) => select_ui_settings(state).map?.marker_size) ?? 32;
    const show_labels = useAppSelector((state) => select_ui_settings(state).map?.marker_labels) ?? false;
    const onSelectDevice = useAction(pickDevice);
    return (_jsx(DeviceMarkers, { markers_info: markers_info, icon_size: icon_size, labels_visible: show_labels, onClick: onSelectDevice }));
});
